import { Outlet, ScrollRestoration } from 'react-router-dom';
import LoadingBar from 'react-redux-loading-bar';
import { useSelector } from 'react-redux';
import { LoginDialog } from './components/shelves/auth/LoginDialog';
import Header from './layouts/Header';
import Sidebar from './layouts/Sidebar';
import ToastList from './components/shelves/notifications/ToastList';

export default function App() {
  const { toastList } = useSelector((state) => state.uiContext);

  return (
    <div className="min-h-screen bg-gray-100 text-gray-900 dark:bg-gray-900 dark:text-gray-100">
      <div className="fixed top-0 z-40 w-full">
        <LoadingBar className="absolute h-[3px] bg-indigo-500 dark:bg-indigo-600" />
      </div>
      <div className="container mx-auto flex h-auto min-h-screen flex-col max-[639px]:pb-16 md:flex-row lg:max-w-5xl xl:max-w-6xl">
        <div className="fixed top-0 left-0 z-30 flex-none py-0 max-[767px]:right-0 md:w-28 lg:sticky lg:mr-4 lg:w-52">
          <div className="h-13 sticky top-0 flex flex-col lg:bottom-0 lg:h-screen lg:px-2">
            <Header />
          </div>
        </div>
        <div className="mx-auto flex h-full w-full min-w-0 grow flex-col self-stretch bg-gray-100 dark:bg-gray-900 sm:w-screen sm:max-w-xl xl:max-w-3xl">
          <div className="container mx-auto mt-6 md:mt-0">
            <Outlet />
          </div>
          <ToastList
            list={toastList}
            position="topRight"
            autoDelete
            autoDeleteTime={3000}
          />
          <LoginDialog />
        </div>
        <div className="hidden px-4 py-3 lg:sticky lg:mt-12 lg:ml-4 lg:block lg:w-52">
          <Sidebar />
        </div>
      </div>
      <ScrollRestoration />
    </div>
  );
}
